import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../api/user.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-folder',
  templateUrl: './folder.page.html',
  styleUrls: ['./folder.page.scss'],
})
export class FolderPage implements OnInit {
  //public folder: string;
  //-------------------------------------------
  /* 'plug into' DOM canvas element using @ViewChild  */
  @ViewChild('canvas0') canvasEl0: ElementRef;
  @ViewChild('canvas') canvasEl: ElementRef;
  @ViewChild('canvas1') canvasEl1: ElementRef;
  @ViewChild('canvas2') canvasEl2: ElementRef;
  @ViewChild('canvas3') canvasEl3: ElementRef;
  @ViewChild('canvas4') canvasEl4: ElementRef;
  @ViewChild('canvas5') canvasEl5: ElementRef;
  @ViewChild('canvas6') canvasEl6: ElementRef;
  /* Reference Canvas object */
  private _CANVAS0: any;
  private _CANVAS: any;
  private _CANVAS1: any;
  private _CANVAS2: any;
  private _CANVAS3: any;
  private _CANVAS4: any;
  private _CANVAS5: any;
  private _CANVAS6: any;
  /* Reference the context for the Canvas element  */
  private _CONTEXT0: any;
  private _CONTEXT: any;
  private _CONTEXT1: any;
  private _CONTEXT2: any;
  private _CONTEXT3: any;
  private _CONTEXT4: any;
  private _CONTEXT5: any;
  private _CONTEXT6: any;
  showON = false;
  temperature: any = 'NA';
  humidity: any = 'NA';
  ceiling: any = 'NA';
  precipitation: any = 'NA';
  convective: any = 'NA';
  midCloud: any = 'NA';
  lowCloud: any = 'NA';
  visibility: any = 'NA';
  windSpeed: any = 'NA';
  windDir: any = 'NA';
  windSpeed150m: any = 'NA';
  windDir150m: any = 'NA';
  data: any = 'NA';
  hour: any = 'NA';
  time: any =  'Select';
  //---------------------------------------------------------
  constructor(private activatedRoute: ActivatedRoute,
    private homeService: UserService,
    public modalController: ModalController) { }

  ngOnInit() {
    // this.folder = this.activatedRoute.snapshot.paramMap.get('id');
    //this.homeService.httpGET();
  }
  // -----------------------------------DESIGN------------------------------------
  start(val) {
    // this.time = val;
    this.showON = true;
    let index = this.homeService.time.indexOf(val);
    this.time = val;
    this.temperature = this.homeService.temperature[index];
    this.humidity = this.homeService.humidity[index];
    this.ceiling = this.homeService.ceiling[index];
    this.precipitation = this.homeService.precipitation[index];
    this.convective = this.homeService.convective[index];
    this.midCloud = this.homeService.midCloud[index];
    this.lowCloud = this.homeService.lowCloud[index];
    this.visibility = this.homeService.visibility[index];
    this.windDir = this.homeService.windDir[index];
    this.windDir150m = this.homeService.windDir150m[index];
    this.windSpeed = this.homeService.windSpeed[index];
    this.windSpeed150m = this.homeService.windSpeed150m[index];
  
    this.hour = this.homeService.temperature[index];
    // ------------------------------------------------------------
    //console.log(this.time);
    this.initialiseCanvas();
    this.draw();
  }

  startOnLoad(){
    this.initialiseCanvas();
    this.draw();
  }

  initialiseCanvas() {
    this._CANVAS0 	    = this.canvasEl0.nativeElement;
    this._CANVAS 	    = this.canvasEl.nativeElement;
    this._CANVAS1 	    = this.canvasEl1.nativeElement;
    this._CANVAS2 	    = this.canvasEl2.nativeElement;
    this._CANVAS3 	    = this.canvasEl3.nativeElement;
    this._CANVAS4 	    = this.canvasEl4.nativeElement;
    this._CANVAS5 	    = this.canvasEl5.nativeElement;
    this._CANVAS6 	    = this.canvasEl6.nativeElement;
    this._CANVAS0.width  	= 100;
    this._CANVAS0.height 	= 100;
    this._CANVAS.width  	= 100;
    this._CANVAS.height 	= 100;
    this._CANVAS1.width  	= 125;
    this._CANVAS1.height 	= 100;
    this._CANVAS2.width  	= 130;
    this._CANVAS2.height 	= 100;
    this._CANVAS3.width  	= 100;
    this._CANVAS3.height 	= 100;
    this._CANVAS4.width  	= 195;
    this._CANVAS4.height 	= 53;
    this._CANVAS5.width  	= 195;
    this._CANVAS5.height 	= 53;
    this._CANVAS6.width  	= 250;
    this._CANVAS6.height 	= 50;
    if (this._CANVAS0.getContext)
    {
        this.setupCanvas0();
    }
    if (this._CANVAS.getContext)
    {
        this.setupCanvas();
    }
    if (this._CANVAS1.getContext)
    {
        this.setupCanvas1();
    }
    if (this._CANVAS2.getContext)
    {
        this.setupCanvas2();
    }
    if (this._CANVAS3.getContext)
    {
        this.setupCanvas3();
    }
    if (this._CANVAS4.getContext)
    {
        this.setupCanvas4();
    }
    if (this._CANVAS5.getContext)
    {
        this.setupCanvas5();
    }
    if (this._CANVAS6.getContext)
    {
        this.setupCanvas6();
    }
  }
  setupCanvas0()
  {
    this._CONTEXT0 = this._CANVAS0.getContext('2d');
    // this._CONTEXT.fillStyle = '#3e3e3e';
    // this._CONTEXT.fillRect(0, 0, 500, 500);
  }
  setupCanvas()
  {
    this._CONTEXT = this._CANVAS.getContext('2d');
    // this._CONTEXT.fillStyle = '#3e3e3e';
    // this._CONTEXT.fillRect(0, 0, 500, 500);
  }
  setupCanvas1()
  {
    this._CONTEXT1 = this._CANVAS1.getContext('2d');
    // this._CONTEXT1.fillStyle = '#3e3e3e';
    // this._CONTEXT1.fillRect(0, 0, 500, 500);
  }
  setupCanvas2()
  {
    this._CONTEXT2 = this._CANVAS2.getContext('2d');
    // this._CONTEXT1.fillStyle = '#3e3e3e';
    // this._CONTEXT1.fillRect(0, 0, 500, 500);
  }
  setupCanvas3()
  {
    this._CONTEXT3 = this._CANVAS3.getContext('2d');
    // this._CONTEXT1.fillStyle = '#3e3e3e';
    // this._CONTEXT1.fillRect(0, 0, 500, 500);
  }
  setupCanvas4()
  {
    this._CONTEXT4 = this._CANVAS4.getContext('2d');
    // this._CONTEXT1.fillStyle = '#3e3e3e';
    // this._CONTEXT1.fillRect(0, 0, 500, 500);
  }
  setupCanvas5()
  {
    this._CONTEXT5 = this._CANVAS5.getContext('2d');
    // this._CONTEXT1.fillStyle = '#3e3e3e';
    // this._CONTEXT1.fillRect(0, 0, 500, 500);
  }
  setupCanvas6()
  {
    this._CONTEXT6 = this._CANVAS6.getContext('2d');
    // this._CONTEXT1.fillStyle = '#3e3e3e';
    // this._CONTEXT1.fillRect(0, 0, 500, 500);
  }

  draw()
  {
    this.clearCanvas();
    this._CONTEXT0.beginPath();
    this._CONTEXT0.font = '15px Arial';
    this._CONTEXT0.fillStyle = '#000000';
    this._CONTEXT0.fillText('CEILING [m]', 8, 15);
    this._CONTEXT0.font = '30px Arial';
    var gradient0 = this._CONTEXT0.createLinearGradient(0, 0, this._CANVAS0.width, 0);
    gradient0.addColorStop('0', 'black');
    this._CONTEXT0.strokeStyle = gradient0;
    this._CONTEXT0.strokeText(this.ceiling, 0, 70);
    // --------------------------------------------------
    this._CONTEXT.beginPath();
    this._CONTEXT.font = '15px Arial';
    this._CONTEXT.fillStyle = '#000000';
    this._CONTEXT.fillText('HUMIDITY', 2, 15);
    this._CONTEXT.font = '30px Arial';
    var gradient = this._CONTEXT.createLinearGradient(0, 0, this._CANVAS.width, 0);
    gradient.addColorStop('0', 'black');
    this._CONTEXT.strokeStyle = gradient;
    this._CONTEXT.strokeText(this.humidity+'%', 2, 70);
    // --------------------------------------------------
    this._CONTEXT1.beginPath();
    this._CONTEXT1.font = '15px Arial';
    this._CONTEXT1.fillStyle = '#000000';
    this._CONTEXT1.fillText('TEMPERATURE', 1, 15);
    this._CONTEXT1.font = '30px Arial';
    var gradient1 = this._CONTEXT.createLinearGradient(0, 0, this._CANVAS1.width, 0);
    gradient1.addColorStop('0', 'black');
    this._CONTEXT1.strokeStyle = gradient1;
    this._CONTEXT1.strokeText(this.temperature+'°C', 15, 70);
    // --------------------------------------------------
    this._CONTEXT2.beginPath();
    this._CONTEXT2.font = '15px Arial';
    this._CONTEXT2.fillStyle = '#000000';
    this._CONTEXT2.fillText('PRECIPITATION', 10, 15);

    var gradient2 = this._CONTEXT2.createLinearGradient(0, 0, this._CANVAS2.width, 0);
    gradient2.addColorStop('0', 'black');
    this._CONTEXT2.strokeStyle = gradient2;
    if (this.precipitation == 0) {
      this._CONTEXT2.font = '30px Arial';
      this._CONTEXT2.strokeText('NO', 45, 70);
    } else {
      this._CONTEXT2.font = '30px Arial';
      this._CONTEXT2.strokeText('RAIN', 40, 70);
    }
    // ------------------------------------------------
    this._CONTEXT3.beginPath();
    this._CONTEXT3.font = '15px Arial';
    this._CONTEXT3.fillStyle = '#000000';
    this._CONTEXT3.fillText('CONVECTIVE*', 2, 15);
    
    var gradient3 = this._CONTEXT3.createLinearGradient(0, 0, this._CANVAS3.width, 0);
    gradient3.addColorStop('0', 'black');
    this._CONTEXT3.strokeStyle = gradient3;
    if (this.convective == 0) {
      this._CONTEXT3.font = '30px Arial';
      this._CONTEXT3.strokeText('NO', 30, 70);
    } else if (this.convective == 11){
      this._CONTEXT3.font = '30px Arial';
      this._CONTEXT3.strokeText('CB', 30, 70);
    } else {
      this._CONTEXT3.font = '30px Arial';
      this._CONTEXT3.strokeText('TS', 30, 70);
    }
    
    // --------------------------------------------------
    this._CONTEXT4.beginPath();
    let grd = this._CONTEXT4.createLinearGradient(0, 0, 195, 0);
    grd.addColorStop(0, 'lightblue');
    this._CONTEXT4.fillStyle = grd;

    this._CONTEXT4.fillRect(0, 0, 195/(100/this.midCloud), 100);
    // --------------------------------------------------
    this._CONTEXT5.beginPath();
    let grd1 = this._CONTEXT5.createLinearGradient(0, 0, 195, 0);
    grd1.addColorStop(0, 'orange');
    this._CONTEXT5.fillStyle = grd1;
    this._CONTEXT5.fillRect(0, 0, 195/(100/this.lowCloud), 100);
    // -------------------------------------------------------
    this._CONTEXT6.beginPath();
    this._CONTEXT6.font = '25px Arial';
    this._CONTEXT6.fillStyle = '#000000';
    this._CONTEXT6.fillText('Visibility [Km]: '+this.visibility, 1, 20);
    
  }

  clearCanvas()
  {
    // this._CONTEXT.clearRect(0, 0, this._CANVAS.width, this._CANVAS.height);
    // this._CONTEXT1.clearRect(0, 0, this._CANVAS1.width, this._CANVAS1.height);
    this.setupCanvas0();
    this.setupCanvas();
    this.setupCanvas1();
    this.setupCanvas2();
    this.setupCanvas3();
    this.setupCanvas4();
    this.setupCanvas5();
    this.setupCanvas6();
  }

}